class CredentialModel {

    constructor(nickName, password) {
        this.nickName = nickName;
        this.password = password;
    }

}

export default CredentialModel